// extracted by mini-css-extract-plugin
export default {"center_block":"Loader_center_block__luTBy","roller":"Loader_roller__q5x3I"};